


















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    quotationAdSpacePrice: number;
    quotationAdSpaceVatPercentage: number;
    quotationAdSpaceServiceFeePrice: number;
    quotationAdSpaceServiceFeeVatPercentage: number;
    quotationTechnicalFeesPrice: number;
    quotationTechnicalFeesVatPercentage: number;
    quotationTechnicalFeesServiceFeePrice: number;
    quotationTechnicalFeesServiceFeeVatPercentage: number;
}

@Component({ components: { SimpleText } })
export default class ServiceFeeQuotation extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "quotationAdSpacePrice",
            "quotationAdSpaceVatPercentage",
            "quotationAdSpaceServiceFeePrice",
            "quotationAdSpaceServiceFeeVatPercentage",
            "quotationTechnicalFeesPrice",
            "quotationTechnicalFeesVatPercentage",
            "quotationTechnicalFeesServiceFeePrice",
            "quotationTechnicalFeesServiceFeeVatPercentage",
        ];
    }

    private includingTaxesPrice(price: number, vatPercentage: number): number {
        return price * (1.0 + (vatPercentage / 100.0));
    }

    private get adSpaceIncludingTaxesPrice(): number {
        return this.includingTaxesPrice(
            this.insertion.quotationAdSpacePrice,
            this.insertion.quotationAdSpaceVatPercentage
        );
    }

    private get technicalFeesIncludingTaxesPrice(): number {
        return this.includingTaxesPrice(
            this.insertion.quotationTechnicalFeesPrice,
            this.insertion.quotationTechnicalFeesVatPercentage
        );
    }

    private get serviceFeesPrice(): number {
        return this.insertion.quotationAdSpaceServiceFeePrice
            + this.insertion.quotationTechnicalFeesServiceFeePrice;
    }

    private get serviceFeesIncludingTaxesPrice(): number {
        return this.includingTaxesPrice(
                this.insertion.quotationAdSpaceServiceFeePrice,
                this.insertion.quotationAdSpaceServiceFeeVatPercentage
            ) + this.includingTaxesPrice(
                this.insertion.quotationTechnicalFeesServiceFeePrice,
                this.insertion.quotationTechnicalFeesServiceFeeVatPercentage
            );
    }



    private get total(): number {
        return this.insertion.quotationAdSpacePrice
            + this.serviceFeesPrice
            + this.insertion.quotationTechnicalFeesPrice;
    }

    private get totalIncludingTaxes(): number {
        return this.adSpaceIncludingTaxesPrice
            + this.technicalFeesIncludingTaxesPrice
            + this.serviceFeesIncludingTaxesPrice;
    }
}
